export const meta = [
    {
        email: "hzayon@msn.com",
        address: "9480 S. Eastern Ave #100 Las Vegas, NV 89123",
        telephone: "702.451.4711",
        telephoneRaw: "7024514711",
    },
]
